export const UI_PORT = 3007;
export const CONTEXT_PATH = '/console';
export const API_PATH = ' ';
export const API_URL = API_PATH;
export const ENV_NAME = '';
export const STRIPE_PK = 'pk_live_51HtxPEGYFZZN9l0lwovfLDs4joziTz8EbRK4ZjVnSNxaItgMchCD7SPDiQ8LaQInR6Nos7VxAn7cS0jaficNCmFw00c3YEB6Uv';

export const BUILD_TAG = 'v1.4.16';

export const BUILD_DATE = 'Sun Sep 15 20:07:42 UTC 2024';

export const BUILD_COMMIT = '8fd95ee591c1d64f5cdac8dab16cedee47131778';
